<template>
  <div class="modal_edit_profile">
    <div class="" v-if="device.client">
      <fg-input
          autocomplete="phone"
          v-model="client_name"
          :type="'tel'"
          :label="translate('client.one')"
          :placeholder="translate('client.one')"
          :disabled="true"
      />
    </div>
    <div class="">
        <sis-select
          v-model="profile.group_id"
          :options="opt_groups"
          :placeholder="translate('groups')"
          :label="translate('group.one')"
          track-by="name"
          :clearable="false"
          :noresult="translate('group.not_found')"
        />
    </div>
    <div class="">
      <fg-input
        v-model="profile.name2"
        type="text"
        :label="translate('device.name')"
        :placeholder="translate('device.name')"
      />
    </div>
    <div class="">
      <fg-input
        v-model="profile.name"
        type="text"
        :label="translate('device.hidden_name')"
        :placeholder="translate('device.hidden_name')"
      />
    </div>
    <div class="">
      <fg-input
        v-model="profile.place"
        type="text"
        :label="translate('device.place')"
        :placeholder="translate('device.place')"
      />
    </div>
    <div class="">
      <fg-input
        v-model="profile.place_full"
        type="text"
        :label="translate('device.place_full')"
        :placeholder="translate('device.place_full')"
      />
    </div>
    <div class="">
      <fg-input
        v-model="profile.desc"
        type="text"
        :label="translate('device.desc')"
        :placeholder="translate('device.desc')"
      />
    </div>
    <div class="">
      <div class="form-group">
        <label>{{ translate('device.desc_add') }}</label>
        <textarea
          v-model="profile.add_desc"
          rows="3"
          class="form-control border-input"
          :placeholder="translate('device.desc_add')"
        />
      </div>
    </div>
    <div class="text-center">
      <button
        v-if="group_change"
        type="submit"
        class="btn btn-info btn-fill btn-wd marginButton"
        @click.prevent="updateDevice(true)"
      >
        {{ translate('device.config.accept_yes') }}
      </button>

      <button
        type="submit"
        class="btn btn-info btn-fill btn-wd marginButton"
        @click.prevent="updateDevice(false)"
      >
        {{ (group_change) ? translate('device.config.accept_no') : translate('save') }}
      </button>

      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>

</template>
<script>

export default {
  props: ['device'],

  data () {
    return {
      acceptConf: false,
      profile: {}
    }
  },
  created() {
    this.profile = {...this.device}
  },
  computed:{
    group_change(){
      return +this.device.group_id !== +this.profile.group_id;
    },
    opt_groups() {
      return this.$store.getters.getDeviceGroupsTree
    },
    client_name(){
      return this.profile.client?.client_name
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    updateDevice(change){
      if (change) {
        this.acceptConf = true
      }
      this.$http.v1.saveDeviceProfile({...this.profile, acceptConf: this.acceptConf}, () => {
        this.global_notify('info', this.translate('profile_saved'))
        this.$store.dispatch('delete_link_device', {group: this.profile.group_id, id: this.device.fid})
        this.$store.commit('updateDeviceProfile', this.profile)

        this.change = false
        this.$emit('change', this.change)
        this.$store.commit('setDeviceListChange', true)
      })
      this.cancel()
    }
  }
}

</script>

<style lang='scss'>
  .modal_edit_profile{
    padding: 10px;
  }
  .marginButton {
    margin: 5px;
  }
  .v-spinner {
    margin-bottom: 10px;
  }
  .tdFont {
    font-weight: bold;
  }
  .block {
    text-align: right;
  }

</style>
